/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPanelExpandRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-panel-expand-right_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-panel-expand-right_svg__st0"
      d="M2 2v20h20V2H2zm12 18H4V4h10v16zm6 0h-4V4h4v16z"
    />
    <path
      className="ico-panel-expand-right_svg__st0"
      d="M11 8.3 7.3 12l3.7 3.7 1.4-1.4-2.3-2.3 2.3-2.3L11 8.3z"
    />
  </Icon>
);
export { SvgPanelExpandRight as PanelExpandRight };
